<template>
    <lamp-tip local-key="mng.dataRule.list">
        <div class="lamptip-desc">
            <p>{{ $t('通过设置共享规则，企业可为员工赋予额外数据权限，实现更加灵活的权限管理。') }}</p>
            <p>{{ $t('共享数据设置不影响员工已有权限角色中的设置。') }}</p>
        </div>
    </lamp-tip>
</template>

<script>
import LampTip from '@/components/lamp-tip';

export default {
  components: {
    LampTip,
  },

  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>

<style lang="less">
.lamptip {
    padding: 20px 0px 0px;
    margin-top: -18px;
}

.lamptip-trigger {
    position: absolute;
    top: -27px;
    right: 0;
    color: #ffb636;

    svg {
        width: 30px;
        height: 30px;
    }

    &:hover {
        color: #ffa623;
    }
}

@media screen and (max-width: 1440px) {
    .lamptip {
        margin-top: -15px;
    }
}
</style>
